import { render, staticRenderFns } from "./Selections.vue?vue&type=template&id=1207c3d8&"
import script from "./Selections.vue?vue&type=script&lang=js&"
export * from "./Selections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports